/* @flow */
import MessageSystemItem from './MessageSystemItem.jsx';
import React from 'react';
import { ChatSystemMessage } from 'entities/ChatMessage';

import './styles/MessageListSystemItem.scss';

class MessageListSystemItem extends React.Component {
  props: {
    messages: ChatSystemMessage[],
  };

  render() {
    const { messages } = this.props;

    return (
      <li className="MessageListSystemItem">
        {messages.map(m => <MessageSystemItem key={m.id} message={m} />)}
      </li>
    );
  }
}

export default MessageListSystemItem;



// WEBPACK FOOTER //
// ./src/chat/components/MessageListSystemItem.jsx